import React, { Component } from 'react';

export default class TypeFolioCellRenderer extends Component {
  render() {
    const { data } = this.props;
    return (
      <div style={{lineHeight:'20px'}}>
         <p
          style={{ margin: 0, padding: 0, color: '#95a5a6', fontSize: '15px' }}
        >
          {data.folio !== undefined ? (
            <span style={{ color: 'green' }}>Nota de Venta</span>
          ) : data.prefolio !== undefined ? (
            <span style={{ color: 'orange' }}>Orden de Venta</span>
          ) : (
            <span style={{ color: 'green' }}>Nota de Venta</span>
          )}
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/TypeFolioCellRenderer.jsx